import { css } from 'styled-components';


export default css`
    position: absolute;
    left: -9999em;
    width: 1px;
    overflow: hidden;
`;
